
/**
 * 
 * @description 自动生成的代码,请勿修改
 */
export default class DtoFinishTask {
    constructor() {
        //无参构造函数
    }

    [proName: string]: any;
    /**
     * 
     */
    PoolId?: string;
}

/**
 * -表单校验
 */
export const DtoFinishTaskRules = {
}
